import { render, staticRenderFns } from "./PrintImgPage.vue?vue&type=template&id=55b9a393&scoped=true"
import script from "./PrintImgPage.vue?vue&type=script&lang=js"
export * from "./PrintImgPage.vue?vue&type=script&lang=js"
import style0 from "./PrintImgPage.vue?vue&type=style&index=0&id=55b9a393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9a393",
  null
  
)

export default component.exports